export const dimensions = {
  BRAND: {
    SUB_DIS: 'sub-dis',
    BMW_DIS: 'bmw-dis',
  },
  COUNTRY: {
    AU: 'au',
  },
};
